module.exports = __webpack_public_path__ + "img/1f63e.da635f1.svg";